import React, { FC } from 'react';
import { ProjectStatusSelect } from 'components/molecules/projects/project-status/project-status-select';
import { ProjectCustomFieldProps } from './type';

export const StatusField: FC<ProjectCustomFieldProps> = ({
  isReadOnly,
  field,
  values,
  onCustomFieldChange,
}) => {
  const statusField = values.find((v) => v.fieldId === field?.fieldId);

  const statusFieldValue = statusField?.metaFieldValue;
  const value = field.metaData?.options
    ?.filter((e) => e.active)
    .find((e) => e.value === statusFieldValue?.value);

  return (
    <ProjectStatusSelect
      isDisabled={isReadOnly}
      value={value}
      onChange={({ value: _value }) => onCustomFieldChange(_value, field)}
    />
  );
};
